import { render, staticRenderFns } from "./statisticsOrganizational.vue?vue&type=template&id=50081436&scoped=true&"
import script from "./statisticsOrganizational.vue?vue&type=script&lang=js&"
export * from "./statisticsOrganizational.vue?vue&type=script&lang=js&"
import style0 from "./statisticsOrganizational.vue?vue&type=style&index=0&id=50081436&lang=stylus&scoped=true&"
import style1 from "./statisticsOrganizational.vue?vue&type=style&index=1&id=50081436&lang=stylus&scoped=true&"
import style2 from "./statisticsOrganizational.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50081436",
  null
  
)

export default component.exports